import { Button } from "@chakra-ui/react"
import { CHAIN_ID } from "@mezo/sdk"

import { selectIsOnEthereumChain, useDappSelector } from "#/redux-state"
import { SDK_NETWORK } from "#/shared/constants"

import SwitchChainButton from "../Buttons/SwitchChainButton"

type WithdrawalModalExtendButtonProps = {
  onClick: () => void
  isDisabled: boolean
}

export default function WithdrawalModalExtendButton({
  onClick,
  isDisabled,
}: WithdrawalModalExtendButtonProps) {
  const hasCorrectChain = useDappSelector(selectIsOnEthereumChain)

  const buttonProps = {
    variant: "secondary",
    size: "large",
    fontFamily: "riforma.bold",
    fontWeight: 500,
    _hover: {
      bg: "primary.red.100",
      borderColor: "primary.white.100",
      color: "primary.white.100",
    },
  }

  if (!hasCorrectChain)
    return (
      <SwitchChainButton
        label="extend"
        chainId={CHAIN_ID[SDK_NETWORK]}
        {...buttonProps}
      />
    )

  return (
    <Button isDisabled={isDisabled} onClick={onClick} {...buttonProps}>
      Extend
    </Button>
  )
}
